export const dataJuegoMitos = [
  {
    mito: "Mito de los celos",
    correcto: 0,
    fraces: [
      "“Sentir o recibir celos es un signo de amor, preocupación y cuidado”",
      "“Le cuento a mi pareja dónde y con quién estoy todo el tiempo”",
      "“Yo soy celoso porque realmente la quiero”",
    ],
    respuestas: [
      "Mito de los celos",
      "Mito de la exclusividad",
      "Mito de la pasión",
      "Mito del destino único",
    ],
    final: `<b style="color: #404040" >Los celos no se vinculan con el amor sino con el temor de perder a otra persona.</b> Sentir celos no está bien ni mal. Ahora bien, ¿cuándo debemos preocuparnos porque los celos se vuelven intensos o posesivos? Ninguna circunstancia nos autoriza a tratar mal a nadie. <b style="color: #404040">La libertad y la confianza son las bases de los acuerdos en nuestras relaciones</b>`,
  },
  {
    mito: "Mito de la media naranja",
    correcto: 0,
    fraces: [
      "“Tenemos un alma gemela”",
      "“Tenemos una persona predestinada que es nuestro amor para toda la vida”",
      "“Cuando estamos sin pareja nos falta algo”",
      "“Siempre hay un roto para un descosido”",
      "“Estamos hechos el uno para el otro”",
    ],
    respuestas: [
      "Mito de los celos",
      "Mito de la exclusividad",
      "Mito de la pasión",
      "Mito de la media naranja",
    ],
    final: `Este mito está relacionado con la <b style="color: #404040">creencia de que las personas solteras, sin pareja, están incompletas</b> y, como consecuencia, no son felices. Según este mito, estar en pareja es  un estado perfecto, verdadero y de plenitud. Tenemos todo lo necesario para sentirnos seres completos, capaces de vivir una vida plena`,
  },
  {
    mito: "Mito de la exclusividad",
    correcto: 0,
    fraces: [
      "“No podemos amar a más de una persona a la vez”",
      "“Tengo que pasar todo mi tiempo libre con la persona que amo”",
      "“El amor de pareja implica la fidelidad”",
      "“El amor es lo más importante y requiere entrega total”",
    ],
    respuestas: [
      "Mito de los celos",
      "Mito de la exclusividad",
      "Mito de la pasión",
      "Mito de los destino",
    ],
    final: `Estar en pareja no <b style="color: #404040">nos compromete a hacer todo de a dos.</b> La pareja es un aspecto de nuestra vida (como las amistades, la familia) con quien nos gusta compartir algo de tiempo, pero no significa compartir todo, todo el tiempo`,
  },
  {
    mito: "Mito del amor todopoderoso",
    correcto: 0,
    fraces: [
      "“El amor real lo puede todo”",
      "“Por amor soportamos cualquier cosa”",
      "“Por amor sería capaz de darlo todo sin esperar nada a cambio”",
    ],
    respuestas: [
      "Mito de los celos",
      "Mito de la exclusividad",
      "Mito de la pasión",
      "Mito del amor todopoderoso",
    ],
    final: `Es la idea de que el verdadero amor todo lo puede. Según este mito, el amor tiene que escalar montañas y soportar todo para ser un gran amor. Esto no tiene por qué ser así. <b style="color: #404040">El amor no duele ni implica sacrificios.</b> Debemos asumir los conflictos y reconocerlos como parte de las relaciones. Amar no es aguantar, sino disfrutar y construir en conjunto`,
  },
  {
    mito: "Mito de la pasión",
    correcto: 0,
    fraces: [
      "“Si desaparece la pasión, es que se ha acabado el amor”",
      "“Si no querés tener relaciones sexuales con tu pareja es porque no le quieres lo suficiente”",
      "“El amor te hace perder la cabeza”",
    ],
    respuestas: [
      "Mito de los celos",
      "Mito de la exclusividad",
      "Mito de la pasión",
      "Mito del destino único",
    ],
    final: `Es la creencia de que, <b style="color: #404040">por amor, podemos perder la razón y el control</b> justificando, incluso, prácticas violentas. Además, según este mito, una pareja perfecta debe <b style="color: #404040">conservar la pasión todo el tiempo.</b> Sin embargo,  todas las relaciones tienen momentos y, como tales, no son definitivos. Hay momentos donde nuestra pasión está puesta en el trabajo, en el estudio, las amistades. Y <b style="color: #404040">no siempre necesitamos lo mismo.</b> Nada es estático, ¡por suerte!`,
  },
  {
    mito: "Mito del destino único",
    correcto: 0,
    fraces: [
      "“El amor conduce al matrimonio”",
      "“Las parejas enamoradas tienen hijos e hijas”",
      "“Una pareja que no proyecta convivir o tener hij@s no tiene futuro”",
      "“Vivieron felices y comieron perdices”",
    ],
    respuestas: [
      "Mito del destino único",
      "Mito de la exclusividad",
      "Mito de la pasión",
      "Mito de los celos",
    ],
    final: `Este mito afirma que <b style="color: #404040">todas las parejas son iguales, desean lo mismo y crecen en la misma dirección.</b> Una pareja que no tiene hij@s o que no convive o que no se casa no significa que no sea una pareja real. Las relaciones que elegimos tienen que hacernos bien. <b style="color: #404040">No existe una sola manera de relacionarse ni la manera correcta de hacerlo.</b>`,
  },
];

export const introGame1 = {
  title: "¿Qué son los mitos del amor romántico?",
  txt: `<b style="color: #404040">Son ideas y creencias que nos cuesta poner en discusión</b> y que nos dicen cómo debe ser una relación amorosa para que sea </b>“amor verdadero”</b>`,
  txt2: `¿Te suenan estas frases? Las escuchamos en el cine, en las letras de las <b style="color: #404040">canciones</b>, en las <b style="color: #404040">publicidades</b>, en las <b style="color: #404040">conversaciones</b> con nuestras amistades…  Uní estas afirmaciones con el mito con que está relacionada.`,
};

export const juegoMitosMFinal = `Desmitificar el amor implica bajarlo del pedestal. Los cuentos, canciones, novelas y películas nos enseñaron sobre el príncipe azul que rescata a la doncella y de princesas que esperan ser salvadas. <b style="color: #404040">Estos vínculos son descriptos como únicos y mágicos aunque impliquen dolor, sacrificio y desigualdad.</b> 
Te invitamos a <b style="color: #404040">repensar el amor -el propio y el que construimos con nuestra pareja-  para despojarlo de estos mandatos y podamos generar relaciones más libres e igualitarias</b>`;
